/* eslint-disable curly */
import mixpanel from 'mixpanel-browser';
import { analytics } from '../util/firebaseConfig';
import { logEvent, setUserId, setUserProperties } from 'firebase/analytics';
export const initialiseCurrentUserProperties = data => {
  const {
    id: { uuid: userId },
    attributes: {
      email,
      createdAt,
      profile: { firstName, lastName, displayName, publicData },
    },
  } = data;

  const type = publicData?.userType || 'user';
  const userType = type.charAt(0).toUpperCase() + type.slice(1);

  mixpanel.identify(userId);

  mixpanel.people.set({
    $email: email,
    $name: displayName,
    $first_name: firstName,
    $last_name: lastName,
    userType,
    createdAt,
  });

  // Set super properties
  mixpanel.register({
    userType,
    userID: userId,
  });
};

export const initialCurrentUser = async ({ firstName, lastName, email, userId, userType }) => {
  mixpanel.people.set_once({
    $name: `${firstName} ${lastName}`,
    $email: email,
    $first_name: firstName,
    $last_name: lastName,
    user_type: userType,
    user_id: userId,
    distinct_id: userId,
  });
  mixpanel.identify(userId);
  (analytics && userId) && setUserId(analytics, userId);
  const displayName = `${firstName} ${lastName}`;
  // Set User Properties
  const userProps = {
    name: displayName,
    first_name: firstName,
    last_name: lastName,
    user_type: userType,
    // created_at: createdAt,
    user_id: userId,
    ...(email && { email }), // Only include if email exists
  };

  (analytics && userId) && setUserProperties(analytics, userProps);
};
export const initialiseAliasMixpanel = async aliasId => {
  try {
    const distinctId = await getMixpanelDistinctId();
    if (distinctId && aliasId && distinctId !== aliasId) {
      mixpanel.alias(aliasId, distinctId);
    }
  } catch (error) {
    console.error('Alias setup failed', error);
  }
};
export const trackEventsFirebase = (eventName, properties = {}) => {
  const timestamp = new Date().toISOString();
  (analytics) && logEvent(analytics, eventName, {
    ...properties,
    device_type: 'web',
    time_stamp: timestamp,
    platform: 'web'
  });
};
export const trackEventsMixpanel = (eventName, properties = {}) => {
  mixpanel.track(eventName, properties);
  trackEventsFirebase(eventName, properties);
};

export const trackEventsTimeMixpanel = eventName => {
  mixpanel.time_event(eventName);
};

export const resetMixpanelId = () => mixpanel.reset();

export const getMixpanelDistinctId = async () => {
  return mixpanel.get_distinct_id();
};
